import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  Injector,
  input,
  runInInjectionContext,
  signal,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { ButtonLinkComponent } from '../../buttons/button-link/button-link.component';
import { forceFocus } from '@mwe/utils';

@Component({
  selector: 'mwe-flipping-content',
  templateUrl: './flipping-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ButtonLinkComponent],
})
export class FlippingContentComponent {
  @ViewChild('flipContent') flipContentRef: ElementRef<HTMLElement>;

  frontCardLabel = input<string>('');
  frontCardAriaLabel = input<string>('');
  backCardLabel = input<string>('');
  backCardAriaLabel = input<string>('');

  isFlipped = signal(false);
  hadUserInteraction = signal<boolean>(false);

  flipBtnLabel = computed(() => (this.isFlipped() ? this.backCardLabel() : this.frontCardLabel()));
  flipBtnAriaLabel = computed(() => (this.isFlipped() ? this.backCardAriaLabel() : this.frontCardAriaLabel()));
  prependIconClass = computed(() => (this.isFlipped() ? 'fas fa-chevron-left' : ''));
  appendIconClass = computed(() => (this.isFlipped() ? '' : 'fas fa-chevron-right'));

  injector = inject(Injector);

  focusHeadline = effect(() => {
    const isFlipped = this.isFlipped();
    runInInjectionContext(this.injector, () => {
      afterNextRender({
        read: () => {
          if (this.hadUserInteraction()) {
            if (isFlipped) {
              forceFocus(this.flipContentRef?.nativeElement.querySelector('[data-force-focus="back"]'), true);
            } else {
              forceFocus(this.flipContentRef?.nativeElement.querySelector('[data-force-focus="front"]'), true);
            }
          }
        },
      });
    });
  });

  private translateService = inject(TranslateService);

  flip(): void {
    this.hadUserInteraction.set(true);
    this.isFlipped.update(value => !value);
  }
}
